import { EstateStatusKey } from '@/modules/estate/constants/EstateStatusKey';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class NotificationEstateStatusUpdatedMeta extends BaseEntityModel {
  parentId?: number;
  oldStatus?: EstateStatusKey;
  newStatus?: EstateStatusKey;

  constructor(model: Partial<NotificationEstateStatusUpdatedMeta> = {}) {
    super(model);

    this.parentId = model.parentId;
    this.oldStatus = model.oldStatus;
    this.newStatus = model.newStatus;
  }
}
